import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './PageLink.module.scss.js';

var _excluded = ["className", "image", "subtitle", "title", "url"];
var PageLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    image = _ref.image,
    subtitle = _ref.subtitle,
    title = _ref.title,
    url = _ref.url,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var classes = cx(styles.pageLink, className);
  return /*#__PURE__*/React.createElement("a", _extends({
    className: classes
  }, props, {
    ref: ref,
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }), image && /*#__PURE__*/React.createElement("div", {
    className: styles.imageContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imageWrapper,
    style: {
      backgroundImage: "url(" + image + ")"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: cx.apply(void 0, [styles.textWrapper].concat(!image && 'block-border-radius'))
  }, title && /*#__PURE__*/React.createElement("h3", null, title), subtitle && /*#__PURE__*/React.createElement("p", null, subtitle)));
});
PageLink.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  image: PropTypes.oneOfType([PropTypes.boolean, PropTypes.string]),
  subtitle: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string.isRequired
};
PageLink.displayName = 'PageLink';

export { PageLink as default };
//# sourceMappingURL=index.js.map
